/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd'
import React, { useEffect } from 'react'
import { Credentials } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { credentialsRegisterSelector, setCredentials, setRegisterStep } from 'src/features'
import {
  RegisterUserStepChanger, CustomTextInput,
  CustomPasswordInput, CustomConfirmPasswordInput, CustomTitle, CustomText
} from 'src/components'

const CredentialsForm: React.FC = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const credentials: Credentials = useAppSelector(credentialsRegisterSelector)

  const onFinish = (values: Credentials) => {
    dispatch(setCredentials(values))
    dispatch(setRegisterStep(2))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['email']: credentials.email,
      ['password']: credentials.password,
      ['confirmPassword']: credentials.confirmPassword,
    })
  }, [credentials])

  return <div className='m-1'>
    <Form
      name='credentialsForm'
      onFinish={onFinish}
      autoComplete='off'
      className='mt-3'
      form={form}
    >
      <div className='register-forms'>
        <CustomTitle type={null} label={t('Auth.Register.Credentials')} />
        <CustomText label={t('Auth.Register.EmailLabel')} type={'secondary'} />

        {/* Email */}
        <CustomTitle className='label-input' label={t('admin.Brokerage.Email')} />
        <CustomTextInput
          name={'email'}
          placeholder={t('admin.Brokerage.EmailPlaceHolder')}
          type='email'
          required
        />

        {/* Password */}
        <CustomTitle className='label-input' label={t('admin.Brokerage.Password')} />
        <CustomPasswordInput
          name={'password'}
          placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
          type='password'
          required
        />
        <CustomText label={t('admin.Brokerage.PassValLabel')} type={'secondary'} />

        {/* Confirm Passowrd */}
        <CustomTitle className='label-input' label={t('admin.Brokerage.ComfirmPassowrd')} />
        <CustomConfirmPasswordInput
          name={'confirmPassword'}
          placeholder={t('admin.Brokerage.ComfirmPassowrdPlaceHolder')}
        />
      </div>
      <RegisterUserStepChanger nextStepValue={2} />
    </Form>
  </div>
}

export default CredentialsForm
